import "./About.css";

function About() {
    return (
        <main>
            <div className="about d-flex flex-column justify-content-center align-items-center">
                <h2 className="text-center mt-5">About</h2>
                <p className="text-center col-8 mt-3">
                    Welcome to our treasure hunting web and mobile app! Our app
                    is the perfect way to have fun, bond with loved ones, and
                    explore new places. With the use of GPS technology, we offer
                    a unique and thrilling experience that challenges users to
                    solve riddles and clues to discover treasures located in
                    hotspots strategically placed to encourage exploration and
                    discovery. <br />
                    Our app features real-time tracking, displaying the current
                    locations of users, treasures, and rewards. By finding
                    treasures, users can earn exciting rewards such as vouchers,
                    discounts, or free services from different establishments.
                    Our scoreboard also highlights the top users who have found
                    the most treasures, adding a competitive element to the
                    experience. <br /> But our app is not just about fun and
                    games, it also supports local businesses and attractions. By
                    promoting tourism in the area where the treasures are
                    located, we encourage people to discover and explore new
                    places, while supporting the growth of local businesses. So
                    what are you waiting for? Join the treasure hunting
                    adventure today and start exploring new places, solving
                    riddles, and discovering hidden treasures while having fun
                    with your friends and family!
                </p>
            </div>
        </main>
    );
}
export default About;
